import { DateTime } from "luxon";

import type { ConditionType } from "@/models/ConditionModel.ts";
import { toDateTime } from "@/utils/dateUtils.ts";

/**
 * The term date only means something for gestational diabetes. The field is hidden for the other
 * types, but react-hook-form keeps its last value (e.g. a gestational patient renewed as Type 2
 * post-partum keeps her past term date): that leftover must neither block the form nor reach the api.
 */
type TermDateInfo = {
  diabetesType?: ConditionType;
  termDate?: string;
};

const isGestational = (diabetesType?: ConditionType) => diabetesType === "gestational";

export const termDateIsValidIfGestational = (data: TermDateInfo) =>
  !isGestational(data.diabetesType) || !data.termDate || toDateTime(data.termDate).isValid;

export const termDateInFutureIfGestational = (data: TermDateInfo) => {
  if (!isGestational(data.diabetesType) || !data.termDate) {
    return true;
  }
  const termDate = toDateTime(data.termDate);
  return !termDate.isValid || termDate > DateTime.now();
};

/** The term date to send to the api: only for a gestational condition. */
export const termDateForCondition = (diabetesType: ConditionType | undefined, termDate: string | undefined) =>
  isGestational(diabetesType) && termDate ? termDate : undefined;
